<!-- 角色设置从表 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj="{}"
      :option="{}"
      :colObj="{
        opId: '6100000093',
        dataClass: 2,
        name: '用户角色修改',
        parentId: 'USER_ID',
        parentName: '用户角色管理',
        parentPath: '/system/user/userRoleManagement',
        addForm: {
          USER_ID: $route.query.USER_ID,
        },
        addClick
      }"
    >
    </Table>
    <wx-select
      ref="wxSelect"
      :visible.sync="selector"
      :select="{
        searchslottitle: '请选择角色',
        searchslotId: 105, // 选择器ID
        searchslotkey: { ID: 'ID',TEAM_NAME: 'TEAM_NAME', $TEAM_NAME: 'TEAM_NAME' },
        multiple: true, // 多选
        loadObj: {
          filterWhere: $route.query.TEAM_NAME, // 搜索框搜索条件
          colname: 'TEAM_NAME' // 搜索列名
        }
      }"
      @return="fn"
    ></wx-select>
  </div>
</template>

<script>
import { addShow } from "@/api/table/table";
import wxSelect from "@/components/table/wxSelect";
import Table from "@/components/table/dataTablecSon";
export default {
  components: {
    wxSelect,
    Table
  },
  data() {
    //这里存放数据
    return {
      selector: false,
      firstEnter: true
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 点击新增
    addClick() {
      this.selector = true;
      this.$refs.wxSelect.selectDataFn([]);
      this.$refs.wxSelect.onLoad();
    },
    // 选择器回调
    fn(param) {
      console.log(param);
      console.log("完整参数:", JSON.stringify(param, null, 2));
      this.selector = false;
      if (param.length === 0) return;
      this.loading = true;
      let arr = param.map(it => {
        return it.id;
      });
      console.log(arr);
      console.log(this.$route.query.USER_ID);
      const userId = this.$route.query.USER_ID;
      const runId = this.$route.query.runId;
      
      // 创建所有请求的 Promise 数组
      const requests = arr.map(teamId => {
        return addShow({
          data: {
            TEAM_ID: teamId, // 每次只传一个 ID
            USER_ID: userId,
          },
          USER_ID: userId,
          runId: runId,
          opid: 6100000093,
          dataClass: 2
        });
      });

      // 使用 Promise.all 并发执行所有请求
      Promise.all(requests)
        .then(res => {
          this.loading = false;
          this.$message.success(`成功添加 ${arr.length} 条记录`);
          this.$refs.table.$refs.child.onLoad();
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("部分或全部操作失败");
          console.error(err);
        });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  activated() {
    if (this.firstEnter) {
      this.firstEnter = false;
    } else {
      this.$refs.table.$refs.child.onLoad();
    }
  } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped></style>
